import apiRequest from "../../utils/apiClient";
import { hostApi } from "../constants";

export const STUDIO_REQUESTS_URL = `${hostApi}studio/requests/`;
export const STUDIO_QUEUE_URL = `${hostApi}studio/queue/`;
export const studioItemUrl = (id: number) => `${hostApi}studio/queue/${id}/`;

export interface MyStudioRequest {
  id: number;
  transcript_id: number;
  transcript_ids?: number[];
  status: "new" | "working" | "delivered" | "declined";
  created_at?: string;
  wants?: string;
  additions?: { at: string; text: string }[];
}

export const postJson = async (url: string, body: unknown) => {
  const res = await apiRequest(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
};

export const getJson = async (url: string) => {
  const res = await apiRequest(url, { method: "GET" });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
};
